import React from 'react';
import PropTypes from 'prop-types';
import Button from '4all-ui/components/Button';
import CloseIcon from '../../../Icons/Close';
import * as styles from './style';
import withCreateProductAddons from '../../../../containers/CreateProductsAddons';
import {
  getVariationOptionLabel,
  getVariationsPriceTypeLabel,
} from '../../../../helpers/variations';
import { formatPrice } from '../../../../helpers/price';

const VariationAddonItem = ({ step, variation, removeStepAddonItem }) => {
  return (
    <styles.VariationContainer>
      <styles.Header>
        <styles.Title className="variation-title">
          {variation.name}
          <Button
            customStyles={{
              border: 'none',
              backgroundColor: 'transparent',
              width: '20px',
              height: '20px',
              minWidth: 'unset',
              padding: 0,
              ':hover': {
                backgroundColor: 'transparent',
              },
            }}
            onClick={() => removeStepAddonItem(step.id)}
            className="remove-variation-item"
          >
            <CloseIcon />
          </Button>
        </styles.Title>
        <styles.Subtitle>
          <styles.Text className="variation-rules">
            {getVariationOptionLabel(variation.min, variation.max, false)}
          </styles.Text>
          <styles.Text className="variation-price-type">
            {getVariationsPriceTypeLabel(variation.priceType)}
          </styles.Text>
        </styles.Subtitle>
      </styles.Header>
      <styles.OptionsList>
        {variation.options.map(option => (
          <styles.Option key={option.id} id={`variation-option-${option.id}`}>
            <styles.OptionName className="variation-option-name">{option.name}</styles.OptionName>
            <styles.OptionPrice className="variation-option-price">
              {formatPrice(option.originalPrice / 100)}
            </styles.OptionPrice>
          </styles.Option>
        ))}
      </styles.OptionsList>
    </styles.VariationContainer>
  );
};

VariationAddonItem.propTypes = {
  variation: PropTypes.string,
  removeStepAddonItem: PropTypes.func.isRequired,
};

export default withCreateProductAddons(VariationAddonItem);



// WEBPACK FOOTER //
// ./src/components/ProductAddons/CustomSteps/VariationAddonItem/index.js